<template>
  <div class="pageV2">
    <el-pagination background @size-change="changeSize" @current-change="changePage"
      :current-page="page" :page-size="size" :total="total" :layout="layout">
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    page: { type: Number, default: 1 },
    size: { type: Number, default: 10 },
    total: { type: Number, default: 0 },
    layout: { type: String, default: "total, prev, pager, next, jumper" },
  },
  data() {
    return {
      currentPage: 4
    }
  },
  methods: {
    changeSize(val) {
      this.$emit("changeSize", val);
    },
    changePage(val) {
      this.$emit("changePage", val);
    }
  },
}
</script>

<style lang="css" scoped>
.pageV2 {
  text-align: center;
  border-top: 1px solid #eee;
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/common/PaginationView.vue